import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";

import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Investor";
import bizSlice from "./features/institutionalInvestor/bizSlice";
import repSlice from "./features/institutionalInvestor/repSlice";
import bankSlice from "./features/institutionalInvestor/bankSlice";
import docSlice from "./features/registration/docSlice";
import bizBorSlice from "./features/merchant/biz";
import disBizSlice from "./features/distributor/biz";
import BorbankSlice from "./features/merchant/bankSlice";
import disBankSlice from "./features/distributor/bank";
import BorrepSlice from "./features/merchant/rep";
import docBorrowerSlice from "./features/merchant/doc";
import profSlice from "./features/indinvestor/profSlice";
import bankSliceInd from "./features/indinvestor/bankSliceInd";
import bulkSlice from "./features/sku/bulkSlice";
import MerchantSlice from "./features/merchant/MerchantSlice/MerchantSlice";
import PaymentTrackingSlice from "./features/merchant/MerchantSlice/PaymentTrackingSlice";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["auth", "biz"], // Add other reducers you want to persist here
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authReducer,
    biz: bizSlice,
    rep: repSlice,
    bank: bankSlice,
    doc: docSlice,
    disBiz: disBizSlice,
    borBiz: bizBorSlice,
    BorBank: BorbankSlice,
    disBank: disBankSlice,
    Borrep: BorrepSlice,
    bordoc: docBorrowerSlice,
    prof: profSlice,
    bankInd: bankSliceInd,
    bulk: bulkSlice,
    merchantReducer: MerchantSlice,
    paymentReducer: PaymentTrackingSlice,
  })
);

const rootReducer = combineReducers({
  merchantReducer: MerchantSlice,
  paymentReducer: PaymentTrackingSlice,
});

const store = configureStore({
  reducer: persistedReducer,
});
const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
